import styled from 'styled-components';

interface ContainerProps {
  gridColumn?: number;
  border?: boolean;
}

interface ButtonProps {
  value?: string;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  cursor: pointer;
  grid-column: ${({gridColumn}) => `span ${gridColumn ?? 12}`};
`;

export const Label = styled.label`
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
`;

export const Button = styled.button<ButtonProps>`
  border: none;
  outline: none;
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
  background-color: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;
  ${(props) => !props.value && `color: rgba(0, 0, 0, 0.6);`}
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  padding: 10px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};

  p {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const Placeholder = styled.span`
  font-weight: 600;
  color: #adb5bd;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;
